import TopHeaderRight from './TopHeaderRight'
import { CobuStack } from '@cobu/ui'
import BrandBadge from './BrandBadge'

export default function TopHeader() {
  return (
    <CobuStack ai="center" jc="space-between" px="$0" py="$0" layout="horizontal" top={0} zIndex={1000} bg="$background" style={{ position: 'sticky' }}>
      <CobuStack w={80} />
      <BrandBadge />
      <TopHeaderRight />
    </CobuStack>
  )
}


